import { render, staticRenderFns } from "./ReturnabilityPromoBanner.vue?vue&type=template&id=e792e2e6&scoped=true"
import script from "./ReturnabilityPromoBanner.vue?vue&type=script&lang=js"
export * from "./ReturnabilityPromoBanner.vue?vue&type=script&lang=js"
import style0 from "./ReturnabilityPromoBanner.vue?vue&type=style&index=0&id=e792e2e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e792e2e6",
  null
  
)

export default component.exports